(function () {

  'use strict';

  // Data that this directive needs
  //
  // [REQUIRED] an audit url from the parent controller
  // [REQUIRED] a reference to the container that sets the height and defines the scroll
  // [OPTIONAL] resourceFilters a constant that allows the radio buttons to become visible

  function pxHistory($rootScope, APIAdmin, AuditEventsListPaging, $timeout, moment) {
    return {
      restrict: 'EA',
      scope: {
        auditEventUrl: '=auditEventUrl',
        containerReference: '=containerReference',
        resourceFiltersData: '=resourceFilters'
      },
      templateUrl: 'app/directives/historyDirective/history.template.html',
      link: function (scope) {

        scope.resourceFilters = scope.resourceFiltersData;
        scope.logLevelsData = null;
        scope.auditListPaging = new AuditEventsListPaging();
        scope.auditListPaging.pagingCriteria.resourceFilter = scope.resourceFiltersData?.SYSTEM;
        scope.auditEvents = [];
        scope.maxPage = 0;

        scope.datePicked = false;
        scope.datePicker = {
          period: {
            startDate: null,
            endDate: null
          }
        };

        scope.dateRangePickerOptions = {
          maxDate: Date.now(),
          autoApply: true,
          timePicker: true,
          timePickerIncrement: 10,
          timePicker24Hour: true,
          eventHandlers: {
            'apply.daterangepicker': function (event, picker) {
              scope.datePicked = true;
              scope.auditListPaging.pagingCriteria.startTime = moment(scope.datePicker.period.startDate).toISOString();
              scope.auditListPaging.pagingCriteria.endTime = moment(scope.datePicker.period.endDate).toISOString();
              getAuditEventsPaged();
            }
          }
        };

        (function () {
          setDefaultLogLevel();
          getAuditEventsPaged();
        })();

        function setDefaultLogLevel() {
          if (scope.resourceFilters) {
            scope.auditListPaging.pagingCriteria.logLevel = 'INFO';
          } else {
            scope.auditListPaging.pagingCriteria.logLevel = 'DEBUG';
          }
        }

        function getAuditEventsPaged() {
          scope.auditListPaging.pagingCriteria.page = 0;
          scope.loadingAuditEventsPage = true;
          scope.auditEvents = [];
          APIAdmin.getAuditEventsPaged(scope.auditEventUrl, scope.auditListPaging)
            .then(function (response) {
              if (checkHistoryRequestOrder(response)) {
                window.scrollTo(0, 0);
                scope.totalPages = response.data.page.totalPages;
                if (response.data._embedded) {
                  scope.auditEvents = response.data._embedded['px:auditEventResources'];
                }
                scope.loadingAuditEventsPage = false;
              }
            })
            .catch(function () {
              scope.loadingAuditEventsPage = false;
            });
        }

        function checkHistoryRequestOrder(response) {
          const latestLogRequest = scope.auditEventUrl + scope.auditListPaging.getPagedUrlParameters(scope.auditListPaging);
          return latestLogRequest === response.config.url;
        }

        scope.resetDatePicker = function () {
          scope.datePicked = false;
          scope.datePicker = {
            period: {
              startDate: null,
              endDate: null
            }
          };
          scope.auditListPaging.pagingCriteria.startTime = null;
          scope.auditListPaging.pagingCriteria.endTime = null;
          getAuditEventsPaged();
        };

        scope.changeResourceFilterType = function () {
          getAuditEventsPaged();
        };

        scope.changeAuditEventsLogLevel = function () {
          scope.auditListPaging.pagingCriteria.logLevel = scope.logLevelsData.selectedLogLevel.command;
          getAuditEventsPaged();
        };

        function setHistoryLevels(user) {
          const logLevelData = {
            logLevels: [
              { name: 'Trace', command: 'TRACE' },
              { name: 'Debug', command: 'DEBUG' },
              { name: 'Info', command: 'INFO' },
              { name: 'WARNING', command: 'WARN' }
            ],
            selectedLogLevel: scope.resourceFilters ? { name: 'Info', command: 'INFO' } : { name: 'Debug', command: 'DEBUG' }
          };
          if (user.info._embedded.permissions.role !== 'PRINTIX_MANAGER') {
            logLevelData.logLevels.shift();
          }
          scope.logLevelsData = logLevelData;
        }

        function getNextAuditEventsPage() {
          if (!scope.loadingAuditEventsPage && scope.totalPages > scope.auditListPaging.pagingCriteria.page + 1) {
            scope.loadingAuditEventsPage = true;
            scope.auditListPaging.pagingCriteria.page += 1;
            APIAdmin.getAuditEventsPaged(scope.auditEventUrl, scope.auditListPaging)
              .then(function (response) {
                if (response.data._embedded) {
                  scope.auditEvents = scope.auditEvents.concat(response.data._embedded['px:auditEventResources']);
                }
                scope.loadingAuditEventsPage = false;
              })
              .catch(function () {
                scope.loadingAuditEventsPage = false;
              });
          }
        }

        let scrollEnd = null;
        let containerHeight = null;
        angular.element(scope.containerReference).on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;
          if (!scope.loadingAuditEventsPage && scope.totalPages > scope.auditListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function () {
                getNextAuditEventsPage();
              }, 300);
            }
          }
        });

        scope.reloadHistory = function () {
          getAuditEventsPaged();
        };

        scope.$on('$destroy', function () {
          angular.element(scope.containerReference).off('scroll');
        });

        scope.$watch(function () {
          return $rootScope.dateRangePickerLanguage;
        }, function () {
          if ($rootScope.dateRangePickerLanguage) {
            scope.dateRangePickerOptions.locale = $rootScope.dateRangePickerLanguage;
          }
        });

        scope.$watch(function () {
          return $rootScope.currentUser;
        }, function () {
          if ($rootScope.currentUser) {
            setHistoryLevels($rootScope.currentUser);
          }
        }, true);

      }
    };
  }

  pxHistory.$inject = ['$rootScope', 'APIAdmin', 'AuditEventsListPaging', '$timeout', 'moment'];

  angular
    .module('printix-admin')
    .directive('pxHistory', pxHistory);

})();
